export const SUPPLIER_NETWORK_PATH = '/supplier-network'

const DIRECTORY_TABS = [
  '/suppliers',
  '/suppliers/founding',
  '/suppliers/verified',
  '/suppliers/favorites'
]

export function isDirectoryPath(pathname: string): boolean {
  return DIRECTORY_TABS.includes(pathname)
}

export function isSupplierProfilePath(pathname: string): boolean {
  return /^\/suppliers\/[^/]+$/.test(pathname) && !isDirectoryPath(pathname)
}

/** the in-app page a signed-in visitor should see instead. */
export function memberPath(pathname: string): string {
  return pathname.replace(/^\/supplier-network/, '/suppliers')
}

export function signupHref(pathname: string): string {
  return `/signup?next=${encodeURIComponent(memberPath(pathname))}`
}
